import { gql }                           from 'apollo-boost';
import { Uuid }                          from "@src/types";
import { getFieldWithProjectIdAccessor } from "@src/util";


export const fragments = {

    HIRE_TYPES: {
        QUERY_RETURN: () =>
                          `id
                          name 
                          description  
                          resourceCode 
                          salary 
                          modifier 
                          businessFunctionId
                          businessFunction { id name colorValue }
                          refIdCode`
    },

    HIRE_TYPE: {
        QUERY_RETURN: ( projectVersionId?: Uuid ) =>
                          `id 
                          name 
                          description 
                          resourceCode 
                          salary 
                          modifier 
                          businessFunctionId
                          businessFunction { id name colorValue }
                          refIdCode
                          `,

        EDIT_FIELDS: ( projectVersionId?: Uuid ) =>
                         `id
                         name
                         description 
                         resourceCode 
                         salary 
                         modifier 
                         businessFunctionId
                         refIdCode
                         `,

        MUTATION_RETURN: ( projectVersionId?: Uuid ) =>
                         `id 
                         name 
                         businessFunctionId
                         resourceCode
                         refIdCode
                         `,
    },

    PROFESSIONAL_FEES: {
        QUERY_RETURN: `id name description resourceCode amount`
    },

    PROFESSIONAL_FEE: {
        QUERY_RETURN:    `id name description resourceCode amount`,
        MUTATION_RETURN: `id name resourceCode`,
        EDIT_FIELDS:     `id refIdCode name description resourceCode amount`,
    },
};

export const queries = {

    GET_HIRE_TYPES: ( returnQueryString = fragments.HIRE_TYPES.QUERY_RETURN() ) => {
        const query = `
        query GetHireTypes( 
            $order: [HireTypeSortInput!], 
            $where: HireTypeFilterInput 
        ){
            hireTypes( order: $order, where: $where)  {
                ${ returnQueryString }
            }
        }`

        return gql( query )
    },

    GET_HIRE_TYPE: ( returnQueryString = fragments.HIRE_TYPE.QUERY_RETURN() ) => {
        const query = `
        query GetHireType( $id: Uuid! ){
            hireTypes( where: { id: { eq: $id } } )  {
                ${ returnQueryString }
            }
        }`

        return gql( query )
    },

    GET_PROFESSIONAL_FEES: ( returnQueryString = fragments.PROFESSIONAL_FEE.QUERY_RETURN ) => {
        const query = `
        query GetHireTypes(
             $order: [ProfessionalFeeSortInput!], 
             $where: ProfessionalFeeFilterInput 
        ){
            professionalFees( order: $order, where: $where)  {
                ${ returnQueryString }
            }
        }`

        return gql( query )
    },

    GET_PROFESSIONAL_FEE: ( returnQueryString = fragments.PROFESSIONAL_FEE.QUERY_RETURN ) => {
        const query = `
        query GetHireType( $id: Uuid! ){
            professionalFees( where: { id: { eq: $id } } )  {
                ${ returnQueryString }
            }
        }`

        return gql( query )
    },
};

export const mutations = {

    /* HIRE TYPES */

    CREATE_HIRE_TYPE: ( returnQueryString = fragments.HIRE_TYPE.MUTATION_RETURN() ) => {
        const query = `
        mutation CreateHireType( $input: HireTypeCreateCommandInput! ){
            createHireType( input: $input ) {
                ${ returnQueryString }
            }
        }`;

        return gql( query );
    },

    UPDATE_HIRE_TYPE: ( returnQueryString = fragments.HIRE_TYPE.MUTATION_RETURN() ) => {
        const query = `
        mutation UpdateHireType( $input: HireTypeUpdateCommandInput! ){
            updateHireType( input: $input ) {
                ${ returnQueryString }
            }
        }`;

        return gql( query );
    },

    DELETE_HIRE_TYPE: () => {
        const query = `
        mutation DeleteHireType( $input: HireTypeDeleteCommandInput! ){
            deleteHireType( input: $input )
        }`;

        return gql( query );
    },

    /* PROFESSIONAL FEES */

    CREATE_PROFESSIONAL_FEE: ( returnQueryString = fragments.PROFESSIONAL_FEE.MUTATION_RETURN ) => {
        const query = `
        mutation CreateHireType( $input: ProfessionalFeeCreateCommandInput! ){
            createProfessionalFee( input: $input ) {
                ${ returnQueryString }
            }
        }`;

        return gql( query );
    },

    UPDATE_PROFESSIONAL_FEE: ( returnQueryString = fragments.PROFESSIONAL_FEE.MUTATION_RETURN ) => {
        const query = `
        mutation UpdateHireType( $input: ProfessionalFeeUpdateCommandInput! ){
            updateProfessionalFee( input: $input ) {
                ${ returnQueryString }
            }
        }`;

        return gql( query );
    },

    DELETE_PROFESSIONAL_FEE: () => {
        const query = `
        mutation DeleteHireType( $input: ProfessionalFeeDeleteCommandInput! ){
            deleteProfessionalFee( input: $input )
        }`;

        return gql( query );
    },

};

export const functions = {}

export const ResourceQueries = {
    fragments,
    queries,
    mutations,
    functions,
};
